module.exports = __webpack_public_path__ + "static/media/grok.5e42b9de.svg";